(function () {
  var REQUIRED_MESSAGE = 'Please fill in field';
  var INVALID_EMAIL_MESSAGE = 'Invalid email';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function escapeSelector(value) {
    if (window.CSS && CSS.escape) {
      return CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseFieldConfigs(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-omp-field-config]'))
      .map(function (script) {
        try {
          return JSON.parse(script.textContent || '{}');
        } catch (error) {
          return null;
        }
      })
      .filter(function (field) {
        return field && field.key && field.label;
      });
  }

  function getFieldValue(form, field) {
    if (field.type === 'file') {
      var fileInput = form.querySelector('[name="' + escapeSelector(field.key) + '"]');
      return fileInput && fileInput.files ? fileInput.files.length : 0;
    }

    if (field.type === 'radio') {
      var checkedRadio = form.querySelector('[name="' + escapeSelector(field.key) + '"]:checked');
      return checkedRadio ? checkedRadio.value : '';
    }

    if (field.type === 'checkbox') {
      return Array.prototype.slice.call(form.querySelectorAll('[name="' + escapeSelector(field.key) + '"]:checked'))
        .map(function (input) {
          return input.value;
        });
    }

    var input = form.querySelector('[name="' + escapeSelector(field.key) + '"]');
    return input ? input.value.trim() : '';
  }

  function validate(form, fields) {
    return fields.reduce(function (errors, field) {
      var value = getFieldValue(form, field);
      var hasValue = Array.isArray(value)
        ? value.length > 0
        : String(value || '').trim() !== '' && value !== 0;

      if (field.required && !hasValue) {
        errors[field.key] = REQUIRED_MESSAGE;
        return errors;
      }

      if (field.type === 'email' && hasValue && !EMAIL_RE.test(String(value))) {
        errors[field.key] = INVALID_EMAIL_MESSAGE;
      }

      return errors;
    }, {});
  }

  function clearMessages(form) {
    form.classList.remove('is-success');

    Array.prototype.slice.call(form.querySelectorAll('.omp-form-field')).forEach(function (field) {
      field.classList.remove('is-invalid');
      Array.prototype.slice.call(field.querySelectorAll('input, textarea')).forEach(function (input) {
        input.removeAttribute('aria-invalid');
      });
    });
    Array.prototype.slice.call(form.querySelectorAll('.omp-form-field-error')).forEach(function (error) {
      error.hidden = true;
      error.textContent = '';
    });

    var status = form.querySelector('.omp-form-status');
    if (status) {
      status.hidden = true;
      status.className = 'omp-form-status body1';
      status.innerHTML = '';
    }
  }

  function renderErrors(form, errors) {
    Object.keys(errors).forEach(function (key) {
      var field = form.querySelector('.omp-form-field[data-omp-field="' + escapeSelector(key) + '"]');
      if (!field) {
        return;
      }

      field.classList.add('is-invalid');
      Array.prototype.slice.call(field.querySelectorAll('input, textarea')).forEach(function (input) {
        input.setAttribute('aria-invalid', 'true');
      });

      var message = field.querySelector('.omp-form-field-error');
      if (message) {
        message.textContent = errors[key];
        message.hidden = false;
      }
    });
  }

  function getSuccessMessageHtml(form, fallbackMessage) {
    var template = form.querySelector('[data-omp-success-message]');
    var templateMessage = template && template.innerHTML
      ? template.innerHTML.trim()
      : '';

    if (templateMessage) {
      return templateMessage;
    }

    return fallbackMessage
      ? '<p>' + escapeHtml(fallbackMessage) + '</p>'
      : '';
  }

  function renderStatus(form, state, title, message) {
    var status = form.querySelector('.omp-form-status');
    if (!status) {
      return;
    }

    status.className = 'omp-form-status body1 is-' + state;
    status.hidden = false;
    form.classList.toggle('is-success', state === 'success');

    if (state === 'success') {
      var successMessage = getSuccessMessageHtml(form, message);

      status.innerHTML = '<div class="omp-form-success-card" tabindex="-1">' +
        '<strong class="omp-form-success-title">' + escapeHtml(title || 'Thanks for your message!') + '</strong>' +
        (successMessage ? '<div class="omp-form-success-message">' + successMessage + '</div>' : '') +
        '</div>';
      return;
    }

    status.innerHTML = title
      ? '<strong class="omp-form-status-title">' + escapeHtml(title) + '</strong>' + escapeHtml(message || '')
      : escapeHtml(message || '');
  }

  function getRecipientEmail(form) {
    var input = form.querySelector('[name="_recipient_email"]');
    return input && input.value ? input.value.trim() : '';
  }

  function buildSubmitFailureMessage(form, message) {
    var recipientEmail = getRecipientEmail(form);
    var baseMessage = message || form.dataset.errorMessage || 'Something went wrong. Please try again.';

    if (!recipientEmail) {
      return baseMessage;
    }

    return baseMessage + ' Please contact an administrator at ' + recipientEmail + '.';
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector('.omp-form-submit');
    form.classList.toggle('is-submitting', isLoading);

    if (isLoading) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }

    if (!button) {
      return;
    }

    var label = button.querySelector ? button.querySelector('.button-text') || button : button;
    if (!button.dataset.defaultLabel && label.textContent) {
      button.dataset.defaultLabel = label.textContent.trim();
    }

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    label.textContent = isLoading
      ? form.dataset.loadingLabel || 'Sending...'
      : button.dataset.defaultLabel || 'Send';
  }

  function updateFileZone(zone) {
    var input = zone.querySelector('input[type="file"]');
    var prompt = zone.querySelector('.omp-form-file-prompt');
    var button = zone.querySelector('.omp-form-file-button');

    if (!input || !prompt) {
      return;
    }

    var defaultPrompt = zone.dataset.defaultPrompt || prompt.textContent;
    var defaultButton = zone.dataset.defaultButton || (button ? button.textContent : 'Browse files');
    zone.dataset.defaultPrompt = defaultPrompt;
    zone.dataset.defaultButton = defaultButton;

    if (input.files && input.files.length > 0) {
      prompt.textContent = input.files.length === 1
        ? input.files[0].name
        : input.files.length + ' files selected';
      zone.classList.add('is-filled');

      if (button) {
        button.textContent = 'Replace';
      }
      return;
    }

    prompt.textContent = defaultPrompt;
    zone.classList.remove('is-filled');

    if (button) {
      button.textContent = defaultButton || 'Browse files';
    }
  }

  function resetFileZones(form) {
    Array.prototype.slice.call(form.querySelectorAll('[data-file-zone]')).forEach(updateFileZone);
  }

  function buildFormData(form, fields) {
    var startedAt = Number(form.dataset.formStartedAt || Date.now());
    if (!isFinite(startedAt) || startedAt <= 0) {
      startedAt = Date.now();
    }

    var elapsedMs = Math.max(0, Date.now() - startedAt);
    var startedAtInput = form.querySelector('[name="_form_started_at"]');
    var elapsedInput = form.querySelector('[name="_form_elapsed_ms"]');

    if (startedAtInput) {
      startedAtInput.value = String(startedAt);
    }

    if (elapsedInput) {
      elapsedInput.value = String(elapsedMs);
    }

    var formData = new FormData(form);
    formData.set('_fields', JSON.stringify(fields));
    formData.set('_source_url', window.location.href);
    formData.set('_form_started_at', String(startedAt));
    formData.set('_form_elapsed_ms', String(elapsedMs));
    return formData;
  }

  function bindForm(form) {
    var fields = parseFieldConfigs(form);
    form.dataset.formStartedAt = String(Date.now());

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessages(form);

      var errors = validate(form, fields);
      if (Object.keys(errors).length > 0) {
        renderErrors(form, errors);
        renderStatus(form, 'error', '', form.dataset.errorMessage || 'Please correct the errors below.');
        return;
      }

      if (!form.action) {
        renderStatus(form, 'error', '', buildSubmitFailureMessage(form));
        return;
      }

      setLoading(form, true);

      fetch(form.action, {
        method: 'POST',
        body: buildFormData(form, fields),
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            if (!response.ok || body.ok === false) {
              var error = new Error(body.error || form.dataset.errorMessage || 'Please try again.');
              error.payload = body;
              throw error;
            }

            return body;
          });
        })
        .then(function () {
          form.reset();
          resetFileZones(form);
          form.dataset.formStartedAt = String(Date.now());
          renderStatus(
            form,
            'success',
            form.dataset.successTitle || '',
            form.dataset.successMessage || ''
          );
        })
        .catch(function (error) {
          if (error.payload && error.payload.errors) {
            renderErrors(form, error.payload.errors);
            renderStatus(form, 'error', '', error.message || form.dataset.errorMessage || 'Please correct the errors below.');
            return;
          }

          renderStatus(form, 'error', '', buildSubmitFailureMessage(form, error.message));
        })
        .finally(function () {
          setLoading(form, false);
        });
    });
  }

  function bindFileZone(zone) {
    var input = zone.querySelector('input[type="file"]');

    if (!input) {
      return;
    }

    updateFileZone(zone);

    input.addEventListener('change', function () {
      updateFileZone(zone);
    });

    ['dragenter', 'dragover'].forEach(function (eventName) {
      zone.addEventListener(eventName, function (event) {
        event.preventDefault();
        zone.classList.add('is-drag');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      zone.addEventListener(eventName, function (event) {
        event.preventDefault();
        zone.classList.remove('is-drag');

        if (eventName === 'drop' && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
          try {
            input.files = event.dataTransfer.files;
          } catch (error) {
            // Some browsers do not allow assigning FileList; native click selection still works.
          }

          updateFileZone(zone);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-file-zone]')).forEach(bindFileZone);
    Array.prototype.slice.call(document.querySelectorAll('.omp-custom-form')).forEach(bindForm);
  });
})();
